import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from 'lodash';
import shortid from "shortid";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Divider } from "@material-ui/core";
import TypeAheadDropdown from "../../../Global/Fields/TypeAheadDropdown";
import GridTextInput from "../../../Global/Fields/GridTextInput";
import GridPercentInput from "../../../Global/Fields/GridPercentInput";

import { transformNumber } from "utils/transformNumber";
import { getDealStages, getDealStatuses, getFundNames } from "store/state/enumeratedTypes";
import PropertyModal from './PropertyModal';
import AddButton from 'components/Global/Buttons/AddButton';
import ExpandableDealProperty from './ExpandableDealProperty';
import { getConfigItemsByParents } from "store/state/configItems";
import { ASSET_CLASS, ASSET_TYPE, ZONING, METROPOLITAN_STATISTICAL_AREA, STATES, REGION, MARKET_VALUE_METHODOLOGY} from "constants/configItemParents";
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
class DealProperties extends React.Component {

  state = {
    editedProperty: null,
    expandedProperties: {},
    isDeletePropertyModalOpen: false,
    isAddPropertyModalOpen:false
  }
  componentDidMount(){
    this.props.getConfigItemsByParents({
      parentIds: [ASSET_CLASS, ASSET_TYPE, ZONING,METROPOLITAN_STATISTICAL_AREA, STATES, REGION, MARKET_VALUE_METHODOLOGY],
      subKey: 'addPropertyModal'
    })
  }
  toggleExpand = propertyId => {
    const {expandedProperties} = {...this.state.expandedProperties};
    if(!expandedProperties[propertyId])
      expandedProperties[propertyId] = {isExpanded: false}
    expandedProperties[propertyId].isExpanded = !expandedProperties[propertyId].isExpanded;
    this.setState({
      expandedProperties
    })
  }
  editProperty = propertyId => {
    let editedProperty = _.find(this.props.properties, {id: propertyId});
    if(!editedProperty)
      console.error('Did not find edited property');
    this.setState({
      editedProperty: {...editedProperty},
      isAddPropertyModalOpen:true,
      isEditing:true
    })
  }
  openDeletePropertyModal = (id) => {
    this.setState({
      isDeletePropertyModalOpen:true,
      idToDelete:id
    });
  }
  confirmDeleteProperty = () => {
    this.props.onDeleteProperty(this.state.idToDelete);
    this.closeDeletePropertyModal();
  }
  closeDeletePropertyModal = () => {
    this.setState({
      isDeletePropertyModalOpen:false,
      idToDelete:null
    })
  }
  onOpenPropertyModal = () => {
    this.setState({
      isAddPropertyModalOpen: true
    })
  }
  closePropertyModal = () => {
    this.setState({
      isAddPropertyModalOpen:false,
      isEditing:false,
      editedProperty: null
    })
  }

  render() {        
    let emptyProperty = {
      actualExitDate: null,
      appraisedValueAsOfDate: null,
      address: "",
      appraisedValue: "",
      assetClassId: "",
      assetTypeId: "",
      capExImprovements: "",
      city: "",
      landSize: "",
      marketValue: "",
      marketValueAsOfDate: null,
      marketValueMethodologyId: "",
      metropolitanStatisticalAreaId: "",
      name: "",
      noi: "",
      noiActual: "",
      noiAsOfDate: null,
      occupancy: "",
      purchasePrice: 0,
      purchaseDate: null,
      projectedExitDate: null,
      regionId: "",
      salesPrice:"",
      squareFeet: "",
      stateId: "",
      yearBuilt: "",
      yearRenovated: "",
      zip: "",
      zoningId: "",
    }
    
    const {expandedProperties,isDeletePropertyModalOpen,isAddPropertyModalOpen,editedProperty,isEditing} = this.state;    
    const {properties, onAddProperty,onEditProperty,propertyConfigItems, isViewOnlyMode , deal, guestPermissions, authentication} = this.props;   
    const unsoldProperties = [];
    const soldProperties = [];
    properties.forEach(property => {
      if(!property.actualExitDate){
        unsoldProperties.push(property);
      }
    });
    properties.forEach(property => {
      if(!!property.actualExitDate){
        soldProperties.push(property);
      }
    });
    if(_.isEmpty(propertyConfigItems))
      return null;
    return (
      <Fragment>
        
        {unsoldProperties.map(x => (
          <span key={`realEstatePropertyContainer${x.id}`} id={`realEstatePropertyContainer${x.id}`}>
          <ExpandableDealProperty 
            key={x.id} 
            property={x} 
            isViewOnlyMode={isViewOnlyMode}
            propertyConfigItems={propertyConfigItems}
            isExpanded={expandedProperties[x.id]}
            onEditProperty={(e) => {              
              e.stopPropagation();
              this.editProperty(x.id);
            }}
            onDeleteProperty={(e) => {
              e.stopPropagation();
              this.openDeletePropertyModal(x.id);
            }}
            onClickExpand={() => this.toggleExpand(x.id)}
            guestPermissions={guestPermissions}
            authentication={authentication}
            />
          </span>
          )
        )}
        {soldProperties.length > 0 && unsoldProperties.length > 0 && <br/>}
        {soldProperties.map(x => (
          <span key={`realEstatePropertyContainer${x.id}`} id={`realEstatePropertyContainer${x.id}`}>
          <ExpandableDealProperty 
            key={x.id} 
            property={x} 
            isViewOnlyMode={isViewOnlyMode}
            propertyConfigItems={propertyConfigItems}
            isExpanded={expandedProperties[x.id]}
            onEditProperty={(e) => {              
              e.stopPropagation();
              this.editProperty(x.id);
            }}
            onDeleteProperty={(e) => {
              e.stopPropagation();
              this.openDeletePropertyModal(x.id);
            }}
            onClickExpand={() => this.toggleExpand(x.id)}
            guestPermissions={guestPermissions}
            authentication={authentication}
            />
          </span>
          )
        )}
        {(!authentication.isGuest) && !isViewOnlyMode && <AddButton id="addRealEstatePropertyButton" title="add a property" onClick={this.onOpenPropertyModal}/>}
        <PropertyModal 
          id="realEstateModel"
          propertyConfigItems={propertyConfigItems}
          isOpen={isAddPropertyModalOpen}
          isEditing={isEditing}
          property={editedProperty || emptyProperty}
          onAdd={onAddProperty}
          onEdit={onEditProperty}
          onClose={this.closePropertyModal}
          deal={deal} />
        <SimpleConfirmDialog
          title="Confirm Delete"
          message="You are about to delete this property. Are you sure you want to do this?"
          modalOpen={isDeletePropertyModalOpen}
          handleNo={this.closeDeletePropertyModal}
          handleYes={this.confirmDeleteProperty}
          noText="No"
          yesText="Yes, Delete"
          />        

      </Fragment>
    );
  }

}

const mapStateToProps = ({configItems, authentication}) => {  
  return {
    authentication,
    propertyConfigItems: configItems.configItemsByParents.addPropertyModal || {}
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemsByParents
    }
  ),  
)(DealProperties);
